import { Route } from 'react-router-dom'
import Login from '../Authentication/components/Login'
import Register from '../Authentication/components/Register'
import Logout from '../Authentication/components/Logout'
import Routes from '../routes'
import ForgotPassword from 'Authentication/components/ForgotPassword'
import ResetPassword from 'Authentication/components/ResetPassword'

const getPublicRoutes = ({ ...rest }) => {
  return [
    <Route
      exact
      key={Routes.REGISTER.PATH}
      path={Routes.REGISTER.PATH}
      render={(props) => <Register {...rest} {...props} />}
    />,
    <Route exact key={Routes.LOGIN.PATH} path={Routes.LOGIN.PATH} render={(props) => <Login {...rest} {...props} />} />,
    <Route
      exact
      key={Routes.LOGOUT.PATH}
      path={Routes.LOGOUT.PATH}
      render={(props) => <Logout {...rest} {...props} />}
    />,
    <Route
      exact
      key={Routes.FORGOT_PASSWORD.PATH}
      path={Routes.FORGOT_PASSWORD.PATH}
      render={(props) => <ForgotPassword {...rest} {...props} />}
    />,
    <Route
      exact
      key={Routes.RESET_PASSWORD.PATH}
      path={Routes.RESET_PASSWORD.PATH}
      render={(props) => <ResetPassword {...rest} {...props} />}
    />
  ]
}

export default getPublicRoutes
